<template>
  <div v-if="show">
    <div class="mask_loading">
      <img src="@/assets/処理中ぐるぐるアニメ.gif" alt="" class="loading" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    show: Boolean
  },
  data() {
    return {}
  }
}
</script>
<style scoped lang="scss">
.loading {
  width: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -40px;
  z-index: 13;
}
.mask_loading {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  position: fixed;
  top: 0;
  z-index: 99999;
  opacity: 0.4;
}
</style>
